module.exports = __webpack_public_path__ + "static/media/tree-stump.ee8fe4ed.jpg";